import { observer } from "mobx-react";
import React from "react";
import {
  Line,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import adminStore from "../../stores/adminStore";

@observer
class TimesDistribution extends React.Component {
  render() {
    const { dashboard } = adminStore;
    const { time_ranges } = dashboard;
    if (!time_ranges) {
      return <div></div>;
    }
    const data = Object.keys(time_ranges).map((tr) => ({
      name: `${tr}`,
      times: time_ranges[tr],
    }));

    const width = window.innerWidth - 240 - 200
    const height = 300

    return (
      <LineChart
        width={width}
        height={height}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="times" name="Respuestas" stroke="#eeaa7b" />
      </LineChart>
    );
  }
}

export { TimesDistribution };
